
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 8.5V14.5C17.5 14.9142 17.1644 15.25 16.7502 15.25H10.75M17.5 8.5V5.5C17.5 5.08579 17.1642 4.75 16.75 4.75H4.75C4.33578 4.75 4 5.08487 4 5.49908V8.5H17.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.75 16V14.5C7.75 13.6716 7.07843 13 6.25 13H3.625M4.375 11.5L2.875 13L4.375 14.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: 'MoneyBackIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>
<style scoped>
</style>
